var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLikeLiteIcon = function SvgLikeLiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20z",
    fill: "#E7E7E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Like_lite_icon_svg__clip0_296_38560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.226 28.816c-1.135-.352-3.724-2.262-5.97-4.256a14.983 14.983 0 01-3.748-5.57 6.082 6.082 0 01.686-5.684 5.2 5.2 0 014.071-2.048 6.677 6.677 0 014.728 1.904 5.811 5.811 0 014.277-2.067 5.18 5.18 0 014.127 1.895 6.18 6.18 0 011.164 5.672 13.762 13.762 0 01-3.484 5.695c-2.072 1.97-4.71 4.191-5.851 4.46z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Like_lite_icon_svg__clip0_296_38560"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLikeLiteIcon;